<div style="display: flex; justify-content: center;">
<mat-card class="example-card">
  <mat-card-title style="color: #252c61;">Report Chart</mat-card-title>
  <table class="table-content">
    <tr class="table-row-content">
      <td>&#x267C; <b>Event Name</b> </td>
      <td style="padding-top: 5px; padding-bottom: 10px;"> &#x267C; <b>Time Duration</b> </td>
    </tr>
    <tr class="table-row-content" style="padding-left: 30px;">
      <td>: {{ eventName }}</td> 
      <td style="padding-top: 5px; padding-bottom: 10px;">: {{ startDate }} -- {{ endDate }}</td>
    </tr>
  </table>
  <hr>

  <mat-card-content>
    <div style="display: block">
      <canvas baseChart
        height="60px"
        [datasets]="barChartData1"
        [labels]="mbarChartLabels1"
        [options]="barChartOptions1"
        [colors]="barChartColors"
        [legend]="barChartLegend"
        [chartType]="barChartType"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
      </canvas>
    </div>
  </mat-card-content>
</mat-card>
</div>


<!-- <div style="margin-left: 450px;">
  ---- <mat-grid-list flex cols="2" rowHeight="500px" gutterSize="0" class="grid-list1"> ----
    ---- <mat-grid-tile class="main"> ----
      <mat-card class="example-card">
        <mat-card-title>Report Chart</mat-card-title>
        <table style="text-align: center;">
          <tr>
            <td><h3>&#x267C;Event Name:-</h3></td>
            <td><h3>{{ eventName }}</h3></td> 
          </tr>
          <tr>
            <td> &#x267C; Time Duration:-</td>
            <td>{{ startDate }} -- {{ endDate }}</td>
          </tr>
        </table>
        <hr>
  
        <mat-card-content>
          <div style="display: block">
            <canvas baseChart
              [datasets]="barChartData1"
              [labels]="mbarChartLabels1"
              [options]="barChartOptions1"
              [colors]="barChartColors"
              [legend]="barChartLegend"
              [chartType]="barChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)">
            </canvas>
          </div>
        </mat-card-content>
      </mat-card>
    ---- </mat-grid-tile> ----
  ---- </mat-grid-list> ----
  </div> -->
  
  <div class="process-wrap"> 
  <table>
    <tr>
    <span *ngFor="let process of allProcesses">
    <span class="arrow" *ngIf="process.processId != allProcesses[0].processId">&#x2799;</span> 
    <td
      class="text_ongoing"
      matTooltip="{{process.processName}} &nbsp; (Ongoing)"
      *ngIf="CurrentDateFinal >= process.startDate &&  process.endDate >= CurrentDateFinal"
      (click)="currentProcess($event.target.innerText,'Ongoing',process.processSeq,process.processId)">
      <h4 style="text-align: center; text-overflow: ellipsis;" class="statusProcessOverflowContent">{{ process.processName }}</h4>
    </td>
    <td 
      class="text_completed"
      matTooltip="{{process.processName}} &nbsp; (Completed)"
     *ngIf=" CurrentDateFinal > process.endDate"
      (click)="currentProcess($event.target.innerText,'Completed',process.processSeq,process.processId)">
      <h4 style="text-align: center; text-overflow: ellipsis;" class="statusProcessOverflowContent">{{ process.processName }}</h4>
    </td>
    <td 
      class="text_upcoming" 
      *ngIf="process.startDate > CurrentDateFinal" 
      matTooltip="{{process.processName}} &nbsp; (Upcoming)"
      (click)="currentProcess($event.target.innerText,'Upcoming',process.processSeq,process.processId)">
      <h4 style="text-align: center; text-overflow: ellipsis;" class="statusProcessOverflowContent">{{ process.processName }}</h4>
    </td>
  </span>
  </tr> 
  </table>
  </div>
  
  <div *ngIf="showDiv==false" id="bottom" style="margin-top: 450px;">
  </div>
  
  <div *ngIf="showDiv">
  <div style="width: 40%; float: left;">
  <mat-grid-list flex cols="1" rowHeight="500px" gutterSize="0" class="grid-list2">
    <mat-grid-tile class="subprocess">
      <mat-card class="process-card">
        <table style="display: flex; flex-direction: row;">
          <tr style="display: flex; flex-direction: column;">
            <td style="font-size: 14px; font-weight: bold;"> Current Process Name</td>
            <td style="font-size: 14px; font-weight: bold; margin-top: 10px;">  Current Process Status</td>
          </tr>
          <tr style="display: flex; flex-direction: column; padding-left: 20px;">
            <td style="color: brown; font-size: 14px; font-weight: bold; display: flex; flex-direction: row; justify-content: space-between;">
              <span> : </span> 
              <span style="padding-left: 10px;">{{ currentProcessName }}</span>
            </td> 
            <td style="color: blue;  font-size: 14px; font-weight: bold; margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start;">
              <span> : </span> 
              <span style="padding-left: 10px;">{{ currentProcessStatus }}</span>
            </td>
          </tr>
        </table>
        <hr>
        <mat-card-content>
          <div style="display: block">
            <canvas baseChart
              [datasets]="barChartData2"
              [labels]="mbarChartLabels2"
              [options]="barchartOptions2"
              [colors]="barChartColors"
              [legend]="barChartLegend"
              [chartType]="barChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)">
            </canvas>
            </div>
        </mat-card-content>
        <span style="color: #003399; font-weight: bold;">Total Students : </span>
        <span style="color: #b300b3">{{ totalStudents }}</span>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
  </div>
  <div style="margin-top: 100px">
    <button mat-raised-button matTooltip="Download Candidate Report" style="background-color: #252c61; color: white;" (click)="downloadStudentData()" >Download <mat-icon>save_alt</mat-icon></button>
  <ag-grid-angular  
      class="ag-theme-balham data-table"
      rowMultiSelectWithClick=true 
      [enableFilter]="true"
      [enableSorting]="true"
      [pagination]="true"
      rowSelection="multiple"
      [rowData]="rowData" 
      (gridReady)="onGridReady($event)"
      [columnDefs]="columnDefs">
  </ag-grid-angular>
  </div>
  <div style="float:right; margin-bottom: 100px; margin-top:50px; margin-left: 100px; margin-right:90px;">
    <!-- <button mat-raised-button color="primary" (click)="downloadStudentData()" >Download <mat-icon>save_alt</mat-icon></button> &nbsp;&nbsp; -->
    <!-- <mat-form-field appearance="fill">
      <mat-label>Email</mat-label>
      <mat-select>
        <mat-option [value]="selected">
          <mat-option>
          Email for Selected Students
        </mat-option>
        <mat-option>
          Email for Rejected Students
        </mat-option>
        <mat-option>
         Waiting Email for Onhold Students
        </mat-option>  
      </mat-select>
    </mat-form-field> &nbsp;
  
    <mat-form-field appearance="fill">
      <mat-label>SMS</mat-label>
      <mat-select>
        <mat-option>
          SMS for Selected Students
        </mat-option>
        <mat-option>
          SMS for Rejected Students
        </mat-option>
        <mat-option>
         Waiting SMS for Onhold Students
        </mat-option>  
      </mat-select>
    </mat-form-field> &nbsp;
  
    <mat-form-field appearance="fill">
      <mat-label>Platform Notification</mat-label>
      <mat-select>
        <mat-option>
          Notify Selected Students
        </mat-option>
        <mat-option>
          Notify Rejected Students
        </mat-option>
        <mat-option>
         Notify Onhold Students to wait
        </mat-option>  
      </mat-select>
    </mat-form-field> &nbsp;
    
    <span *ngIf="visible"> 
    <mat-form-field appearance="fill">
      <mat-label>Final Round</mat-label>
      <mat-select>
        <mat-option>
          Share offer letters
        </mat-option>
        <mat-option>
          Request Documents
        </mat-option>  
      </mat-select>
    </mat-form-field> &nbsp;
    </span> -->
  </div>
  </div>